import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import styles from './MainScreenWrapper.module.scss';
import {
  ConfirmStartTreatmentModal,
  CreatePatientCaseModal,
  CreateUserModal,
  EditPatientModal,
  Header,
  LogoutModal,
  ReassignToCurrentUserModal,
  RemoveAssignmentModal,
  Sidebar,
  TasksStageModal,
  ToggleArchivePatientCaseModal,
  ToggleDeletePatientCaseModal,
  ToggleTreatmentModal,
  TreatmentAndDiagnosisErrorModal,
} from 'components';
import { UploadPatientFilesModal } from 'components/UploadFilesModal/UploadPatientFilesModal';
import { useCreatePatient, usePullToRefresh } from 'hooks';
import { PatientLinksModal } from 'pages/Patient/components/PatientProfile/components/PatientLinks/components/PatientLinksModal/PatientLinksModal';
import { selectAppModals } from 'store/app/selectors';
import { usersActions } from 'store/users/slice';
import { useDispatch, useSelector } from 'store/utils';

export const MainScreenWrapper = () => {
  const dispatch = useDispatch();

  const { isOpen: isCreatePatientCaseModalOpen } = useCreatePatient();

  const [mobileMenuIsOpen, setMobileMenuIsOpen] = useState(false);
  const modals = useSelector(selectAppModals);

  const onToggleMenuHandler = () => {
    setMobileMenuIsOpen((prev) => !prev);
  };

  const onCloseMenuHandler = () => {
    setMobileMenuIsOpen(false);
  };

  useEffect(() => {
    dispatch(usersActions.getUsers());
  }, [dispatch]);

  usePullToRefresh();

  return (
    <div className={styles.container}>
      <Sidebar isMobileMenuOpen={mobileMenuIsOpen} closeMobileMenu={onCloseMenuHandler} />
      <div className={styles.mainPageContainer}>
        <Header isMobileMenuOpen={mobileMenuIsOpen} toggleMobileMenu={onToggleMenuHandler} />
        <div className={styles.contentPageContainer}>
          <Outlet />
        </div>
      </div>
      {modals.createUser && <CreateUserModal />}
      {modals.logout && <LogoutModal />}
      {isCreatePatientCaseModalOpen && <CreatePatientCaseModal />}
      {modals.editPatientInfo && <EditPatientModal />}
      {modals.archivePatient && <ToggleArchivePatientCaseModal />}
      {modals.uploadPatientFiles && <UploadPatientFilesModal />}
      {modals.removeAssignment && <RemoveAssignmentModal />}
      {modals.reassignUser && <ReassignToCurrentUserModal />}
      {modals.tasksModal && <TasksStageModal />}
      {modals.treatmentModal && <ToggleTreatmentModal />}
      {modals.addPatientLinks && <PatientLinksModal />}
      {modals.treatmentAndDiagnosisError && <TreatmentAndDiagnosisErrorModal />}
      {modals.startTreatment && <ConfirmStartTreatmentModal />}
      {modals.deletePatient && <ToggleDeletePatientCaseModal />}
    </div>
  );
};
